import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.previewUrl && _ctx.isActive)
      ? _withDirectives((_openBlock(), _createElementBlock("video", {
          key: 0,
          autoplay: true,
          muted: true,
          loop: true,
          playsinline: true,
          src: _ctx.previewUrl,
          class: "content-image",
          ref: "video"
        }, null, 8, _hoisted_1)), [
          [_vShow, _ctx.isPlaying]
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Image, _mergeProps(_ctx.$attrs, {
      "image-url": _ctx.imageUrl,
      "is-lcp": _ctx.isLcp,
      alt: ""
    }), null, 16, ["image-url", "is-lcp"]), [
      [_vShow, !_ctx.isPlaying]
    ])
  ], 64))
}